import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "cert-manage-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "my-ip-area" }
const _hoisted_4 = { class: "my-ip-box" }
const _hoisted_5 = { class: "ip-value" }
const _hoisted_6 = { class: "cert-body" }
const _hoisted_7 = { class: "cert-main-layout" }
const _hoisted_8 = { class: "content-card" }
const _hoisted_9 = { class: "search-area" }
const _hoisted_10 = { class: "facility-info" }
const _hoisted_11 = { class: "facility-name" }
const _hoisted_12 = { class: "facility-code" }
const _hoisted_13 = {
  key: 1,
  class: "action-disabled"
}
const _hoisted_14 = {
  key: 0,
  class: "cert-detail-sidebar"
}
const _hoisted_15 = { class: "sidebar-header" }
const _hoisted_16 = { class: "sidebar-content" }
const _hoisted_17 = {
  key: 0,
  class: "sidebar-download-bar"
}
const _hoisted_18 = { class: "detail-section" }
const _hoisted_19 = { class: "detail-row" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "detail-row" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "detail-row" }
const _hoisted_24 = { class: "value mono" }
const _hoisted_25 = { class: "detail-row" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "detail-section" }
const _hoisted_28 = { class: "detail-row" }
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "detail-row" }
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "detail-row" }
const _hoisted_33 = { class: "detail-row" }
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "detail-row" }
const _hoisted_36 = { class: "value" }
const _hoisted_37 = { class: "detail-row" }
const _hoisted_38 = { class: "value" }
const _hoisted_39 = {
  key: 1,
  class: "detail-section ltcs-secrets-section"
}
const _hoisted_40 = {
  key: 0,
  class: "secret-row"
}
const _hoisted_41 = { class: "secret-value-wrap" }
const _hoisted_42 = { class: "secret-value" }
const _hoisted_43 = {
  key: 1,
  class: "no-ips"
}
const _hoisted_44 = {
  key: 2,
  class: "detail-section"
}
const _hoisted_45 = { class: "detail-section" }
const _hoisted_46 = { class: "section-header" }
const _hoisted_47 = {
  key: 0,
  class: "ip-loading"
}
const _hoisted_48 = {
  key: 1,
  class: "no-ips"
}
const _hoisted_49 = {
  key: 2,
  class: "ip-list"
}
const _hoisted_50 = { class: "ip-info" }
const _hoisted_51 = { class: "ip-address" }
const _hoisted_52 = {
  key: 0,
  class: "ip-desc"
}
const _hoisted_53 = { class: "ip-actions" }
const _hoisted_54 = { class: "cert-main-layout" }
const _hoisted_55 = { class: "content-card" }
const _hoisted_56 = { class: "search-area" }
const _hoisted_57 = { class: "hope-table-wrap" }
const _hoisted_58 = { class: "facility-info" }
const _hoisted_59 = { class: "facility-name" }
const _hoisted_60 = { class: "facility-code" }
const _hoisted_61 = {
  key: 1,
  class: "action-disabled"
}
const _hoisted_62 = {
  key: 0,
  class: "cert-detail-sidebar hope-cert-sidebar"
}
const _hoisted_63 = { class: "sidebar-header" }
const _hoisted_64 = { class: "sidebar-content" }
const _hoisted_65 = {
  key: 0,
  class: "sidebar-download-bar"
}
const _hoisted_66 = { class: "detail-section" }
const _hoisted_67 = { class: "detail-row" }
const _hoisted_68 = { class: "value" }
const _hoisted_69 = { class: "detail-row" }
const _hoisted_70 = { class: "value" }
const _hoisted_71 = { class: "detail-row" }
const _hoisted_72 = { class: "value mono" }
const _hoisted_73 = { class: "detail-row" }
const _hoisted_74 = { class: "value" }
const _hoisted_75 = { class: "detail-section" }
const _hoisted_76 = { class: "detail-row" }
const _hoisted_77 = { class: "value" }
const _hoisted_78 = { class: "detail-row" }
const _hoisted_79 = { class: "value" }
const _hoisted_80 = { class: "detail-row" }
const _hoisted_81 = { class: "detail-row" }
const _hoisted_82 = { class: "value" }
const _hoisted_83 = { class: "detail-row" }
const _hoisted_84 = { class: "value" }
const _hoisted_85 = {
  key: 1,
  class: "detail-section hope-secrets-section"
}
const _hoisted_86 = { class: "secret-row" }
const _hoisted_87 = { class: "secret-value-wrap" }
const _hoisted_88 = { class: "secret-value" }
const _hoisted_89 = { class: "secret-row" }
const _hoisted_90 = { class: "secret-value" }
const _hoisted_91 = { class: "secret-row" }
const _hoisted_92 = { class: "secret-value-wrap" }
const _hoisted_93 = { class: "secret-value" }
const _hoisted_94 = {
  key: 1,
  class: "no-ips"
}
const _hoisted_95 = {
  key: 2,
  class: "detail-section"
}
const _hoisted_96 = ["disabled"]
const _hoisted_97 = { class: "ip-input-row" }
const _hoisted_98 = ["disabled"]
const _hoisted_99 = { class: "ip-to-delete" }
const _hoisted_100 = {
  key: 0,
  class: "ip-desc-to-delete"
}

import { ref, computed, onMounted, watch } from 'vue';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import { certApi, hopeCertApi } from '@/services/api';

interface CertItem {
  cic_idx: number;
  m_code: string;
  m_name: string;
  m_longterm_code: string;
  m_biz_gubun: string;
  cic_cert_name: string;
  cic_expire_date: string;
  cic_status: string;
  cic_last_used: string;
  cic_upload_ip: string;
  cic_wdate: string;
  ip_count: number;
}

interface HopeCertItem {
  chc_idx: number;
  m_code: string;
  m_name: string;
  m_longterm_code: string;
  m_biz_gubun: string;
  chc_cert_name: string;
  chc_expire_date: string;
  chc_status: string;
  chc_last_used: string;
  chc_upload_ip: string;
  chc_wdate: string;
}

interface AllowedIP {
  ccai_idx: number;
  cic_idx: number;
  ccai_ip: string;
  ccai_description: string;
  ccai_is_active: number;
  ccai_wdate: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CertManagePage',
  setup(__props) {

const activeTab = ref<'ltcs' | 'hope'>('ltcs');

const loading = ref(false);
const certs = ref<CertItem[]>([]);
const searchKeyword = ref('');
const statusFilter = ref('all');
const selectedCert = ref<CertItem | null>(null);
const myIP = ref('');

const ltcsSecrets = ref<{
  certPassword: string;
  hasFiles: boolean;
} | null>(null);
const ltcsSecretsLoading = ref(false);
const ltcsSecretsError = ref('');
const downloadingLtcsCode = ref('');
const showLtcsCertPw = ref(false);

const hopeLoading = ref(false);
const hopeCerts = ref<HopeCertItem[]>([]);
const hopeSearchKeyword = ref('');
const hopeStatusFilter = ref('active');
const selectedHopeCert = ref<HopeCertItem | null>(null);
const hopeSecrets = ref<{
  certPassword: string;
  hopeId: string;
  hopePw: string;
  hasFiles: boolean;
} | null>(null);
const hopeSecretsLoading = ref(false);
const hopeSecretsError = ref('');
const downloadingHopeCode = ref('');
const showHopeCertPw = ref(false);
const showHopeHopePw = ref(false);

const allowedIPs = ref<AllowedIP[]>([]);
const loadingIPs = ref(false);

const showAddIpDialog = ref(false);
const addingIP = ref(false);
const newIP = ref({ ip: '', description: '' });

const showDeleteIpDialog = ref(false);
const deletingIP = ref(false);
const ipToDelete = ref<AllowedIP | null>(null);

const statusOptions = [
  { title: '전체 상태', value: 'all' },
  { title: '활성', value: 'active' },
  { title: '만료됨', value: 'expired' },
  { title: '폐기됨', value: 'revoked' }
];

const headers = [
  { title: '기관명', key: 'm_name', sortable: true },
  { title: '사업구분', key: 'm_biz_gubun', sortable: false },
  { title: '인증서명', key: 'cic_cert_name', sortable: true },
  { title: '만료일', key: 'cic_expire_date', sortable: true },
  { title: '상태', key: 'cic_status', sortable: true },
  { title: '허용 IP', key: 'ip_count', sortable: false },
  { title: '마지막 사용', key: 'cic_last_used', sortable: true },
  { title: '등록일', key: 'cic_wdate', sortable: true },
  { title: '다운로드', key: 'actions', sortable: false },
];

const hopeHeaders = [
  { title: '기관명', key: 'm_name', sortable: true },
  { title: '사업구분', key: 'm_biz_gubun', sortable: false },
  { title: '인증서명', key: 'chc_cert_name', sortable: true },
  { title: '만료일', key: 'chc_expire_date', sortable: true },
  { title: '상태', key: 'chc_status', sortable: true },
  { title: '마지막 사용', key: 'chc_last_used', sortable: true },
  { title: '등록일', key: 'chc_wdate', sortable: true },
  { title: '다운로드', key: 'actions', sortable: false },
];

const filteredCerts = computed(() => {
  let result = [...certs.value];

  if (statusFilter.value !== 'all') {
    result = result.filter(c => c.cic_status === statusFilter.value);
  }

  if (searchKeyword.value) {
    const keyword = searchKeyword.value.toLowerCase();
    result = result.filter(c =>
      (c.m_name || '').toLowerCase().includes(keyword) ||
      (c.cic_cert_name || '').toLowerCase().includes(keyword) ||
      (c.m_longterm_code || '').toLowerCase().includes(keyword)
    );
  }

  return result;
});

const filteredHopeCerts = computed(() => {
  let result = [...hopeCerts.value];

  if (hopeStatusFilter.value !== 'all') {
    result = result.filter((c) => c.chc_status === hopeStatusFilter.value);
  }

  if (hopeSearchKeyword.value) {
    const keyword = hopeSearchKeyword.value.toLowerCase();
    result = result.filter((c) =>
      (c.m_name || '').toLowerCase().includes(keyword) ||
      (c.chc_cert_name || '').toLowerCase().includes(keyword) ||
      (c.m_longterm_code || '').toLowerCase().includes(keyword) ||
      (c.m_code || '').toLowerCase().includes(keyword)
    );
  }

  return result;
});

const formatDate = (date: string): string => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('ko-KR');
};

const formatDateTime = (date: string): string => {
  if (!date) return '-';
  return new Date(date).toLocaleString('ko-KR');
};

const getExpireColor = (expireDate: string): string => {
  if (!expireDate) return 'grey';
  const diff = new Date(expireDate).getTime() - Date.now();
  const days = diff / (1000 * 60 * 60 * 24);
  if (days < 0) return 'error';
  if (days < 30) return 'warning';
  return 'success';
};

const getStatusColor = (status: string): string => {
  switch (status) {
    case 'active': return 'success';
    case 'expired': return 'error';
    case 'revoked': return 'grey';
    case 'deleted': return 'grey';
    default: return 'grey';
  }
};

const getStatusText = (status: string): string => {
  switch (status) {
    case 'active': return '활성';
    case 'expired': return '만료됨';
    case 'revoked': return '폐기됨';
    case 'deleted': return '삭제됨';
    default: return status;
  }
};

const loadCerts = async () => {
  loading.value = true;
  try {
    const res = await certApi.getAllCerts();
    certs.value = res.data.data || [];
  } catch (error: any) {
    const msg = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`롱텀케어 인증서 목록 조회 실패: ${msg}`);
  } finally {
    loading.value = false;
  }
};

const loadHopeCerts = async () => {
  hopeLoading.value = true;
  try {
    const res = await hopeCertApi.getAllCerts();
    hopeCerts.value = res.data?.data || [];
  } catch (error: any) {
    const msg = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`희망이음 인증서 목록 조회 실패: ${msg}`);
  } finally {
    hopeLoading.value = false;
  }
};

const loadHopeSecrets = async (mCode: string) => {
  hopeSecretsLoading.value = true;
  hopeSecrets.value = null;
  hopeSecretsError.value = '';
  showHopeCertPw.value = false;
  showHopeHopePw.value = false;
  try {
    const res = await hopeCertApi.adminGetSecrets(mCode);
    hopeSecrets.value = res.data?.data || null;
  } catch (error: any) {
    hopeSecrets.value = null;
    hopeSecretsError.value = error.response?.data?.message || error.message || '비밀정보 조회 실패';
  } finally {
    hopeSecretsLoading.value = false;
  }
};

const selectHopeCert = async (cert: HopeCertItem) => {
  selectedHopeCert.value = cert;
  if (cert.chc_status === 'active') {
    await loadHopeSecrets(cert.m_code);
  } else {
    hopeSecrets.value = null;
    hopeSecretsError.value = '';
  }
};

const closeHopeSidebar = () => {
  selectedHopeCert.value = null;
  hopeSecrets.value = null;
  hopeSecretsError.value = '';
};

const downloadHopeCertZip = async (item?: HopeCertItem) => {
  const target = item || selectedHopeCert.value;
  if (!target || downloadingHopeCode.value) return;
  downloadingHopeCode.value = target.m_code;
  try {
    const mCode = target.m_code;
    const safeName = String(target.chc_cert_name || target.m_name || mCode)
      .replace(/[^\w가-힣().-]/g, '_');
    await hopeCertApi.adminDownloadZip(mCode, `hope-cert_${safeName}.zip`);
  } catch (error: any) {
    const msg = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`인증서 다운로드 실패: ${msg}`);
  } finally {
    downloadingHopeCode.value = '';
  }
};

const loadLtcsSecrets = async (mCode: string) => {
  ltcsSecretsLoading.value = true;
  ltcsSecrets.value = null;
  ltcsSecretsError.value = '';
  showLtcsCertPw.value = false;
  try {
    const res = await certApi.adminGetSecrets(mCode);
    ltcsSecrets.value = res.data?.data || null;
  } catch (error: any) {
    ltcsSecrets.value = null;
    ltcsSecretsError.value = error.response?.data?.message || error.message || '비밀정보 조회 실패';
  } finally {
    ltcsSecretsLoading.value = false;
  }
};

const downloadLtcsCertZip = async (item?: CertItem) => {
  const target = item || selectedCert.value;
  if (!target || downloadingLtcsCode.value) return;
  if (target.cic_status !== 'active') {
    alert('활성 상태 인증서만 다운로드할 수 있습니다.');
    return;
  }
  downloadingLtcsCode.value = target.m_code;
  try {
    const mCode = target.m_code;
    const safeName = String(target.cic_cert_name || target.m_name || mCode)
      .replace(/[^\w가-힣().-]/g, '_');
    await certApi.adminDownloadZip(mCode, `ltcs-cert_${safeName}.zip`);
  } catch (error: any) {
    const msg = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`인증서 다운로드 실패: ${msg}`);
  } finally {
    downloadingLtcsCode.value = '';
  }
};

const selectCert = async (cert: CertItem) => {
  selectedCert.value = cert;
  loadAllowedIPs(cert.cic_idx);
  if (cert.cic_status === 'active') {
    await loadLtcsSecrets(cert.m_code);
  } else {
    ltcsSecrets.value = null;
    ltcsSecretsError.value = '';
  }
};

const loadAllowedIPs = async (cicIdx: number) => {
  loadingIPs.value = true;
  try {
    const res = await certApi.getAllowedIPs(cicIdx);
    allowedIPs.value = res.data.data || [];
  } catch (error: any) {
    console.error('허용 IP 목록 로드 실패:', error);
    allowedIPs.value = [];
  } finally {
    loadingIPs.value = false;
  }
};

const openIpModal = (cert: CertItem) => {
  selectCert(cert);
};

const openAddIpDialog = () => {
  newIP.value = { ip: '', description: '' };
  showAddIpDialog.value = true;
};

const addIP = async () => {
  if (!newIP.value.ip || !selectedCert.value) return;

  addingIP.value = true;
  try {
    await certApi.addAllowedIP(selectedCert.value.cic_idx, {
      ip: newIP.value.ip.trim(),
      description: newIP.value.description.trim()
    });
    showAddIpDialog.value = false;
    loadAllowedIPs(selectedCert.value.cic_idx);
    loadCerts();
  } catch (error: any) {
    const msg = error.response?.data?.message || '허용 IP 추가에 실패했습니다.';
    alert(msg);
  } finally {
    addingIP.value = false;
  }
};

const confirmDeleteIP = (ip: AllowedIP) => {
  ipToDelete.value = ip;
  showDeleteIpDialog.value = true;
};

const deleteIP = async () => {
  if (!ipToDelete.value || !selectedCert.value) return;

  deletingIP.value = true;
  try {
    await certApi.deleteAllowedIP(ipToDelete.value.ccai_idx);
    showDeleteIpDialog.value = false;
    loadAllowedIPs(selectedCert.value.cic_idx);
    loadCerts();
  } catch (error: any) {
    alert('허용 IP 삭제에 실패했습니다.');
  } finally {
    deletingIP.value = false;
  }
};

const toggleIP = async (ip: AllowedIP, isActive: boolean) => {
  try {
    await certApi.toggleAllowedIP(ip.ccai_idx, isActive);
    ip.ccai_is_active = isActive ? 1 : 0;
  } catch (error: any) {
    alert('상태 변경에 실패했습니다.');
  }
};

const loadMyIP = async () => {
  try {
    const res = await certApi.getMyIP();
    myIP.value = res.data.data?.ip || '';
  } catch (error) {
    console.error('IP 조회 실패:', error);
    myIP.value = '조회 실패';
  }
};

const copyMyIP = () => {
  if (!myIP.value) return;
  
  // Clipboard API 지원 여부 확인
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(myIP.value).then(() => {
      alert(`IP가 복사되었습니다: ${myIP.value}`);
    }).catch(() => {
      fallbackCopy(myIP.value);
    });
  } else {
    fallbackCopy(myIP.value);
  }
};

const fallbackCopy = (text: string) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-9999px';
  document.body.appendChild(textArea);
  textArea.select();
  try {
    document.execCommand('copy');
    alert(`IP가 복사되었습니다: ${text}`);
  } catch (err) {
    alert(`복사 실패. IP를 직접 복사해주세요: ${text}`);
  }
  document.body.removeChild(textArea);
};

const applyMyIP = () => {
  if (myIP.value) {
    newIP.value.ip = myIP.value;
  }
};

onMounted(() => {
  loadCerts();
  loadHopeCerts();
  loadMyIP();
});

watch(activeTab, (tab) => {
  if (tab === 'hope' && hopeCerts.value.length === 0) {
    loadHopeCerts();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "title-area" }, [
        _createElementVNode("h2", { class: "page-title" }, "인증서 관리"),
        _createElementVNode("p", { class: "page-subtitle" }, "롱텀케어·희망이음 공인인증서 조회 및 관리 (최고관리자 전용)")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_icon, {
            size: "18",
            class: "ip-icon"
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
              _createTextVNode("mdi-web", -1)
            ]))]),
            _: 1
          }),
          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "ip-label" }, "현재 접속 IP:", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(myIP.value || '조회중...'), 1),
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            size: "x-small",
            onClick: copyMyIP,
            title: "IP 복사"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode("mdi-content-copy", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_v_tabs, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      class: "cert-type-tabs",
      density: "compact"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "ltcs" }, {
          default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
            _createTextVNode("롱텀케어 공인인증서", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "hope" }, {
          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
            _createTextVNode("희망이음 공동인증서", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_6, [
      (activeTab.value === 'ltcs')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_v_text_field, {
                    modelValue: searchKeyword.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchKeyword).value = $event)),
                    placeholder: "기관명, 인증서명 검색",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    "prepend-inner-icon": "mdi-magnify",
                    class: "search-input",
                    clearable: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_select, {
                    modelValue: statusFilter.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((statusFilter).value = $event)),
                    items: statusOptions,
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    class: "status-select"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode(_component_v_data_table, {
                  headers: headers,
                  items: filteredCerts.value,
                  loading: loading.value,
                  class: "cert-table",
                  hover: "",
                  "onClick:row": _cache[3] || (_cache[3] = (_, { item }: any) => selectCert(item))
                }, {
                  "item.m_name": _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(item.m_name || '-'), 1),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(item.m_longterm_code || ''), 1)
                    ])
                  ]),
                  "item.m_biz_gubun": _withCtx(({ item }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item.m_biz_gubun || '').split(','), (biz) => {
                      return (_openBlock(), _createBlock(_component_v_chip, {
                        key: biz,
                        size: "x-small",
                        class: "biz-chip"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(biz.trim()), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  "item.cic_cert_name": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(item.cic_cert_name || '-'), 1)
                  ]),
                  "item.cic_expire_date": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: getExpireColor(item.cic_expire_date),
                      size: "small",
                      variant: "flat"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formatDate(item.cic_expire_date)), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.cic_status": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: getStatusColor(item.cic_status),
                      size: "small",
                      variant: "flat"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getStatusText(item.cic_status)), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.ip_count": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "primary",
                      size: "small",
                      variant: "outlined",
                      onClick: _withModifiers(($event: any) => (openIpModal(item)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.ip_count) + "개 ", 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  "item.cic_last_used": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(item.cic_last_used ? formatDateTime(item.cic_last_used) : '-'), 1)
                  ]),
                  "item.cic_wdate": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(formatDate(item.cic_wdate)), 1)
                  ]),
                  "item.actions": _withCtx(({ item }) => [
                    (item.cic_status === 'active')
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          variant: "flat",
                          class: "btn-table-download",
                          size: "small",
                          loading: downloadingLtcsCode.value === item.m_code,
                          onClick: _withModifiers(($event: any) => (downloadLtcsCertZip(item)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "14" }, {
                              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                _createTextVNode("mdi-download", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[28] || (_cache[28] = _createTextVNode(" ZIP ", -1))
                          ]),
                          _: 1
                        }, 8, ["loading", "onClick"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, "-"))
                  ]),
                  _: 1
                }, 8, ["items", "loading"])
              ])
            ]),
            (selectedCert.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[30] || (_cache[30] = _createElementVNode("h3", null, "인증서 상세", -1)),
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (selectedCert.value = null))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                            _createTextVNode("mdi-close", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (selectedCert.value.cic_status === 'active')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_v_btn, {
                            variant: "flat",
                            class: "btn-download",
                            loading: downloadingLtcsCode.value === selectedCert.value.m_code,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (downloadLtcsCertZip()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                size: "16",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                  _createTextVNode("mdi-download", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[32] || (_cache[32] = _createTextVNode(" 인증서 ZIP 다운로드 ", -1))
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[37] || (_cache[37] = _createElementVNode("h4", null, "기관 정보", -1)),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "label" }, "기관명", -1)),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(selectedCert.value.m_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _cache[34] || (_cache[34] = _createElementVNode("span", { class: "label" }, "기관코드", -1)),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(selectedCert.value.m_longterm_code), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[35] || (_cache[35] = _createElementVNode("span", { class: "label" }, "m_code", -1)),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(selectedCert.value.m_code), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "label" }, "사업구분", -1)),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(selectedCert.value.m_biz_gubun), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _cache[44] || (_cache[44] = _createElementVNode("h4", null, "인증서 정보", -1)),
                      _createElementVNode("div", _hoisted_28, [
                        _cache[38] || (_cache[38] = _createElementVNode("span", { class: "label" }, "발급자명", -1)),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(selectedCert.value.cic_cert_name || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _cache[39] || (_cache[39] = _createElementVNode("span", { class: "label" }, "만료일", -1)),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(formatDate(selectedCert.value.cic_expire_date)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "label" }, "상태", -1)),
                        _createVNode(_component_v_chip, {
                          color: getStatusColor(selectedCert.value.cic_status),
                          size: "small",
                          variant: "flat"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getStatusText(selectedCert.value.cic_status)), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _cache[41] || (_cache[41] = _createElementVNode("span", { class: "label" }, "업로드 IP", -1)),
                        _createElementVNode("span", _hoisted_34, _toDisplayString(selectedCert.value.cic_upload_ip || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _cache[42] || (_cache[42] = _createElementVNode("span", { class: "label" }, "등록일", -1)),
                        _createElementVNode("span", _hoisted_36, _toDisplayString(formatDateTime(selectedCert.value.cic_wdate)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _cache[43] || (_cache[43] = _createElementVNode("span", { class: "label" }, "마지막 사용", -1)),
                        _createElementVNode("span", _hoisted_38, _toDisplayString(selectedCert.value.cic_last_used ? formatDateTime(selectedCert.value.cic_last_used) : '-'), 1)
                      ])
                    ]),
                    (selectedCert.value.cic_status === 'active')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _cache[46] || (_cache[46] = _createElementVNode("h4", null, "비밀정보", -1)),
                          _createVNode(LoadingOverlay, {
                            show: ltcsSecretsLoading.value,
                            text: "비밀정보 불러오는 중...",
                            variant: "light"
                          }, null, 8, ["show"]),
                          (ltcsSecrets.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                _cache[45] || (_cache[45] = _createElementVNode("span", { class: "label" }, "인증서 비밀번호", -1)),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("span", _hoisted_42, _toDisplayString(showLtcsCertPw.value ? ltcsSecrets.value.certPassword : '••••••••'), 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "secret-toggle-btn",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (showLtcsCertPw.value = !showLtcsCertPw.value))
                                  }, [
                                    _createVNode(_component_v_icon, { size: "16" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(showLtcsCertPw.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]))
                            : (!ltcsSecretsLoading.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(ltcsSecretsError.value || '비밀번호를 불러오지 못했습니다.'), 1))
                              : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_44, [...(_cache[47] || (_cache[47] = [
                          _createElementVNode("p", { class: "inactive-cert-hint" }, "활성 상태 인증서만 비밀정보 조회 및 다운로드가 가능합니다.", -1)
                        ]))])),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _cache[50] || (_cache[50] = _createElementVNode("h4", null, "허용 IP 목록", -1)),
                        _createVNode(_component_v_btn, {
                          size: "small",
                          variant: "flat",
                          class: "btn-register",
                          onClick: openAddIpDialog
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "small",
                              class: "mr-1"
                            }, {
                              default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                _createTextVNode("mdi-plus", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[49] || (_cache[49] = _createTextVNode(" IP 추가 ", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      (loadingIPs.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _createVNode(_component_v_progress_circular, {
                              indeterminate: "",
                              size: "24"
                            })
                          ]))
                        : (allowedIPs.value.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, " 등록된 허용 IP가 없습니다. "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allowedIPs.value, (ip) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: ip.ccai_idx,
                                  class: _normalizeClass(["ip-item", { inactive: !ip.ccai_is_active }])
                                }, [
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("span", _hoisted_51, _toDisplayString(ip.ccai_ip), 1),
                                    (ip.ccai_description)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(ip.ccai_description), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_53, [
                                    _createVNode(_component_v_switch, {
                                      "model-value": !!ip.ccai_is_active,
                                      "hide-details": "",
                                      density: "compact",
                                      color: "primary",
                                      "onUpdate:modelValue": ($event: any) => (toggleIP(ip, $event as boolean))
                                    }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      variant: "text",
                                      size: "small",
                                      color: "error",
                                      onClick: ($event: any) => (confirmDeleteIP(ip))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "small" }, {
                                          default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                            _createTextVNode("mdi-delete", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ], 2))
                              }), 128))
                            ]))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createVNode(_component_v_text_field, {
                    modelValue: hopeSearchKeyword.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((hopeSearchKeyword).value = $event)),
                    placeholder: "기관명, 인증서명, 기관코드 검색",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    "prepend-inner-icon": "mdi-magnify",
                    class: "search-input",
                    clearable: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_select, {
                    modelValue: hopeStatusFilter.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((hopeStatusFilter).value = $event)),
                    items: statusOptions,
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    class: "status-select"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(LoadingOverlay, {
                    show: hopeLoading.value,
                    text: "불러오는 중..."
                  }, null, 8, ["show"]),
                  _createVNode(_component_v_data_table, {
                    headers: hopeHeaders,
                    items: filteredHopeCerts.value,
                    class: "cert-table",
                    hover: "",
                    "onClick:row": _cache[9] || (_cache[9] = (_, { item }: any) => selectHopeCert(item))
                  }, {
                    "item.m_name": _withCtx(({ item }) => [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("span", _hoisted_59, _toDisplayString(item.m_name || '-'), 1),
                        _createElementVNode("span", _hoisted_60, _toDisplayString(item.m_longterm_code || item.m_code || ''), 1)
                      ])
                    ]),
                    "item.m_biz_gubun": _withCtx(({ item }) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item.m_biz_gubun || '').split(','), (biz) => {
                        return (_openBlock(), _createBlock(_component_v_chip, {
                          key: biz,
                          size: "x-small",
                          class: "biz-chip"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(biz.trim()), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    "item.chc_cert_name": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(item.chc_cert_name || '-'), 1)
                    ]),
                    "item.chc_expire_date": _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        color: getExpireColor(item.chc_expire_date),
                        size: "small",
                        variant: "flat"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(formatDate(item.chc_expire_date)), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    "item.chc_status": _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        color: getStatusColor(item.chc_status),
                        size: "small",
                        variant: "flat"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getStatusText(item.chc_status)), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    "item.chc_last_used": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(item.chc_last_used ? formatDateTime(item.chc_last_used) : '-'), 1)
                    ]),
                    "item.chc_wdate": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatDate(item.chc_wdate)), 1)
                    ]),
                    "item.actions": _withCtx(({ item }) => [
                      (item.chc_status === 'active')
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            variant: "flat",
                            class: "btn-table-download",
                            size: "small",
                            loading: downloadingHopeCode.value === item.m_code,
                            onClick: _withModifiers(($event: any) => (downloadHopeCertZip(item)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "14" }, {
                                default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                  _createTextVNode("mdi-download", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[53] || (_cache[53] = _createTextVNode(" ZIP ", -1))
                            ]),
                            _: 1
                          }, 8, ["loading", "onClick"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_61, "-"))
                    ]),
                    _: 1
                  }, 8, ["items"])
                ])
              ])
            ]),
            (selectedHopeCert.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _cache[55] || (_cache[55] = _createElementVNode("h3", null, "희망이음 인증서", -1)),
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text",
                      onClick: closeHopeSidebar
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                            _createTextVNode("mdi-close", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    (selectedHopeCert.value.chc_status === 'active')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                          _createVNode(_component_v_btn, {
                            variant: "flat",
                            class: "btn-download",
                            loading: downloadingHopeCode.value === selectedHopeCert.value.m_code,
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (downloadHopeCertZip()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                size: "16",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                  _createTextVNode("mdi-download", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[57] || (_cache[57] = _createTextVNode(" 인증서 ZIP 다운로드 ", -1))
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_66, [
                      _cache[62] || (_cache[62] = _createElementVNode("h4", null, "기관 정보", -1)),
                      _createElementVNode("div", _hoisted_67, [
                        _cache[58] || (_cache[58] = _createElementVNode("span", { class: "label" }, "기관명", -1)),
                        _createElementVNode("span", _hoisted_68, _toDisplayString(selectedHopeCert.value.m_name || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _cache[59] || (_cache[59] = _createElementVNode("span", { class: "label" }, "장기요양기관기호", -1)),
                        _createElementVNode("span", _hoisted_70, _toDisplayString(selectedHopeCert.value.m_longterm_code || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _cache[60] || (_cache[60] = _createElementVNode("span", { class: "label" }, "m_code", -1)),
                        _createElementVNode("span", _hoisted_72, _toDisplayString(selectedHopeCert.value.m_code), 1)
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _cache[61] || (_cache[61] = _createElementVNode("span", { class: "label" }, "사업구분", -1)),
                        _createElementVNode("span", _hoisted_74, _toDisplayString(selectedHopeCert.value.m_biz_gubun || '-'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _cache[68] || (_cache[68] = _createElementVNode("h4", null, "인증서 정보", -1)),
                      _createElementVNode("div", _hoisted_76, [
                        _cache[63] || (_cache[63] = _createElementVNode("span", { class: "label" }, "발급자명", -1)),
                        _createElementVNode("span", _hoisted_77, _toDisplayString(selectedHopeCert.value.chc_cert_name || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _cache[64] || (_cache[64] = _createElementVNode("span", { class: "label" }, "만료일", -1)),
                        _createElementVNode("span", _hoisted_79, _toDisplayString(formatDate(selectedHopeCert.value.chc_expire_date)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _cache[65] || (_cache[65] = _createElementVNode("span", { class: "label" }, "상태", -1)),
                        _createVNode(_component_v_chip, {
                          color: getStatusColor(selectedHopeCert.value.chc_status),
                          size: "small",
                          variant: "flat"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getStatusText(selectedHopeCert.value.chc_status)), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _cache[66] || (_cache[66] = _createElementVNode("span", { class: "label" }, "등록일", -1)),
                        _createElementVNode("span", _hoisted_82, _toDisplayString(formatDateTime(selectedHopeCert.value.chc_wdate)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_83, [
                        _cache[67] || (_cache[67] = _createElementVNode("span", { class: "label" }, "마지막 사용", -1)),
                        _createElementVNode("span", _hoisted_84, _toDisplayString(selectedHopeCert.value.chc_last_used ? formatDateTime(selectedHopeCert.value.chc_last_used) : '-'), 1)
                      ])
                    ]),
                    (selectedHopeCert.value.chc_status === 'active')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                          _cache[72] || (_cache[72] = _createElementVNode("h4", null, "비밀정보", -1)),
                          _createVNode(LoadingOverlay, {
                            show: hopeSecretsLoading.value,
                            text: "비밀정보 불러오는 중...",
                            variant: "light"
                          }, null, 8, ["show"]),
                          (hopeSecrets.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_86, [
                                  _cache[69] || (_cache[69] = _createElementVNode("span", { class: "label" }, "인증서 비밀번호", -1)),
                                  _createElementVNode("div", _hoisted_87, [
                                    _createElementVNode("span", _hoisted_88, _toDisplayString(showHopeCertPw.value ? hopeSecrets.value.certPassword : '••••••••'), 1),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "secret-toggle-btn",
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (showHopeCertPw.value = !showHopeCertPw.value))
                                    }, [
                                      _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(showHopeCertPw.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_89, [
                                  _cache[70] || (_cache[70] = _createElementVNode("span", { class: "label" }, "희망이음 아이디", -1)),
                                  _createElementVNode("span", _hoisted_90, _toDisplayString(hopeSecrets.value.hopeId || '-'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_91, [
                                  _cache[71] || (_cache[71] = _createElementVNode("span", { class: "label" }, "희망이음 비밀번호", -1)),
                                  _createElementVNode("div", _hoisted_92, [
                                    _createElementVNode("span", _hoisted_93, _toDisplayString(showHopeHopePw.value ? hopeSecrets.value.hopePw : '••••••••'), 1),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "secret-toggle-btn",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (showHopeHopePw.value = !showHopeHopePw.value))
                                    }, [
                                      _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(showHopeHopePw.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ])
                              ], 64))
                            : (!hopeSecretsLoading.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(hopeSecretsError.value || '비밀번호를 불러오지 못했습니다. 위 다운로드 버튼은 사용 가능합니다.'), 1))
                              : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_95, [...(_cache[73] || (_cache[73] = [
                          _createElementVNode("p", { class: "inactive-cert-hint" }, "활성 상태 인증서만 비밀정보 조회 및 다운로드가 가능합니다.", -1)
                        ]))]))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showAddIpDialog.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((showAddIpDialog).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "dialog-title" }, {
              default: _withCtx(() => [
                _cache[75] || (_cache[75] = _createElementVNode("span", null, "IP 추가", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "dialog-title__close",
                  disabled: addingIP.value,
                  "aria-label": "닫기",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (showAddIpDialog.value = false))
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ], 8, _hoisted_96)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_97, [
                  _createVNode(_component_v_text_field, {
                    modelValue: newIP.value.ip,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((newIP.value.ip) = $event)),
                    label: "IP 주소",
                    placeholder: "예: 123.456.789.0",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_btn, {
                    variant: "outlined",
                    size: "small",
                    class: "apply-my-ip-btn",
                    onClick: applyMyIP,
                    disabled: !myIP.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                          _createTextVNode("mdi-crosshairs-gps", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[77] || (_cache[77] = _createTextVNode(" 현재주소 ", -1))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _createVNode(_component_v_text_field, {
                  modelValue: newIP.value.description,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((newIP.value.description) = $event)),
                  label: "설명 (선택)",
                  placeholder: "예: 본사 PC, 김대리 노트북",
                  variant: "outlined",
                  density: "compact",
                  class: "mt-3"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-cancel",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (showAddIpDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                    _createTextVNode("취소", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-save",
                  onClick: addIP,
                  loading: addingIP.value
                }, {
                  default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                    _createTextVNode("추가", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showDeleteIpDialog.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((showDeleteIpDialog).value = $event)),
      "max-width": "360"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "dialog-title" }, {
              default: _withCtx(() => [
                _cache[81] || (_cache[81] = _createElementVNode("span", null, "IP 삭제", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "dialog-title__close",
                  disabled: deletingIP.value,
                  "aria-label": "닫기",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (showDeleteIpDialog.value = false))
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[80] || (_cache[80] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ], 8, _hoisted_98)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _cache[82] || (_cache[82] = _createElementVNode("p", null, "다음 IP를 삭제하시겠습니까?", -1)),
                _createElementVNode("p", _hoisted_99, _toDisplayString(ipToDelete.value?.ccai_ip), 1),
                (ipToDelete.value?.ccai_description)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_100, _toDisplayString(ipToDelete.value.ccai_description), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-cancel",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (showDeleteIpDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                    _createTextVNode("취소", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-delete",
                  onClick: deleteIP,
                  loading: deletingIP.value
                }, {
                  default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                    _createTextVNode("삭제", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})